<template>
  <router-view/>
</template>

<script>
import Parse from 'parse'
import ParseConfig from './api/parse.config';

export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      isLoggedIn: false,
    };
  },
  async created() {
    ParseConfig();
    if (Parse.User.current()) {
      this.isLoggedIn = true;
    }
  },
};
</script>

<style>
html
{
  height:100%;
  width:100%;
}
body 
{
  height:100%;
  width:100%;
  margin:0;
  padding:0;
  overflow:hidden;
}
#app
{
  height:100%;
  width:100%;
}
</style>
